module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b')])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b', [_vm._v("Chapter Two")])])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b')])]), _vm._v(" "), _c('p', {
    staticClass: "tcd"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("With the motherly-generous west wind filling their brown triangular sails, the slim war galley and the five broad-beamed grain ships, two nights out of Lankhmar, coursed north in line ahead across the Inner Sea of the ancient world of Nehwon."), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("It was late afternoon of one of those mild blue days when sea and sky are the same hue, providing irrefutable evidence for the hypothesis currently favored by Lankhmar philosophers: that Nehwon is a giant bubble rising through the waters of eternity with continents, islands, and the great jewels that at night are the stars all orderly afloat on the bubble’s inner surface."), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("On the afterdeck of the last grain ship, which was also the largest, the Gray Mouser spat a plum skin to leeward and boasted luxuriously, “Fat times in Lankhmar! Not one day returned to the City of the Black Toga after months away adventuring and we get this cushy job from the Overlord himself—and with an advance on pay too.”"), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“I have an old distrust of cushy jobs,” Fafhrd replied, yawning and pulling his fur-trimmed jerkin open wider so that the mild wind might trickle more fully through the tangled hair-field of his chest. “And we were rushed out of Lankhmar so quickly that we had not even time to pay our respects to the ladies. Nevertheless I must confess that we might have done worse. A full purse is the best ballast for any man-ship, especially one bearing letters of marque against ladies.”"), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Ship’s Master Slinoor looked back with hooded appraising eyes at the small lithe gray-clad man and his tall, more gaudily accoutered barbarian comrade. The master of "), _c('i', [_vm._v("Squid")]), _vm._v(" was a sleek black-robed man of middle years. He stood beside the two stocky black-tunicked bare-legged sailors who held steady the great high-arching tiller that guided "), _c('i', [_vm._v("Squid")]), _vm._v("."), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“How much do you two rogues really know of your cushy job?” Slinoor asked softly. “Or rather, how much did the arch-noble Glipkerio choose to tell you of the purpose and dark antecedents of this voyaging?” Two days of fortunate sailing seemed at last to have put the closed-mouthed ship’s master in a mood to exchange confidences, or at least trade queries and lies."), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("From a bag of netted cord that hung by the taffrail, the Mouser speared a night-purple plum with the dirk he called Cat’s Claw. Then he answered lightly, “This fleet bears a gift of grain from Overlord Glipkerio to Movarl of the Eight Cities in gratitude for Movarl’s sweeping the Mingol pirates from the Inner Sea and mayhap diverting the steppe-dwelling Mingols from assaulting Lankhmar across the Sinking Land. Movarl needs grain for his hunter-farmers turned cityman-soldiers and especially to supply his army relieving his border city of Klelg Nar, which the Mingols besiege. Fafhrd and I are, you might say, a small but mighty rear-guard for the grain and for certain more delicate items of Glipkerio’s gift.”"), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“You mean those?” Slinoor bent a thumb toward the larboard rail."), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('i', [_vm._v("Those")]), _vm._v(" were twelve large white rats distributed among four silver-barred cages. With their silky coats, pale-rimmed blue eyes and especially their short, arched upper lips and two huge upper incisors, they looked like a clique of haughty, bored, inbred aristocrats, and it was in a bored aristocratic fashion that they were staring at a scrawny black kitten which was perched with dug-in claws on the starboard rail, as if to get as far away from the rats as possible, and staring back at them most worriedly."), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Fafhrd reached out and ran a finger down the black kitten’s back. The kitten arched its spine, losing itself for a moment in sensuous delight, but then edged away and resumed its worried rat-peering—an activity shared by the two black-tunicked helmsmen, who seemed both resentful and fearful of the silver-caged afterdeck passengers."), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The Mouser sucked plum juice from his fingers and flicked out his tongue-tip to neatly capture a drop that threatened to run down his chin. Then, “No, I mean not chiefly those high-bred gift-rats,” he replied to Slinoor and kneeling lightly and unexpectedly and touching two fingers significantly to the scrubbed oak deck, he said, “I mean chiefly "), _c('i', [_vm._v("she")]), _vm._v(" who is below, who ousts you from your master’s cabin, and who now insists that the gift-rats require sunlit and fresh air—which strikes me as a strange way of cosseting burrow- and shadow-dwelling vermin.”"), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Slinoor’s cropped eyebrows rose. He came close and whispered, “You think the Demoiselle Hisvet may not be merely the conductress of the rat-gift, but also herself part of Glipkerio’s gift to Morvarl? Why, she’s the daughter of the greatest grain-merchant in Lankhmar, who’s grown rich selling tawny corn to Glipkerio.”"), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The Mouser smiled cryptically but said nothing."), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Slinoor frowned, then whispered ever lower, “True, I’ve heard the story that Hisvet has already been her father Hisvin’s gift to Glipkerio to buy his patronage.”"), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Fafhrd, who’d been trying to stroke the kitten again with no more success than to chase it up the aftermast, turned around at that. “Why, Hisvet’s but a child,” he said almost reprovingly. “A most prim and proper miss. I know not of Glipkerio, he seems decadent”—the word was not an insult in Lankhmar—“but surely Movarl, a Northerner albeit a forest man, likes only strong-beamed, ripe, complete women.”"), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Your own tastes, no doubt?” the Mouser remarked, gazing at Fafhrd with half-closed eyes. “No traffic with child-like women?”"), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Fafhrd blinked as if the Mouser had dug fingers in his side. Then he shrugged and said loudly, “What’s so special about these rats? Do they do tricks?”"), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Aye,” Slinoor said distastefully. “They play at being men. They’ve been trained by Hisvet to dance to music, to drink from cups, hold tiny spears and swords, even fence. I’ve not seen it—nor would care to.”"), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The picture struck the Mouser’s fancy. He envisioned himself small as a rat, dueling with rats who wore lace at their throats and wrists, slipping through the mazy tunnels of their underground cities, becoming a great connoisseur of cheese and smoked meats, perchance wooing a slim rat-queen and being surprised by her rat-king husband and having to dagger-fight him in the dark. Then he noted one of the white rats looking at him intently through the silver bars with a cold inhuman blue eye and suddenly his idea didn’t seem amusing at all. He shivered in the sunlight."), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Slinoor was saying, “It is not good for animals to try to be men.” "), _c('i', [_vm._v("Squid")]), _vm._v("’s skipper gazed somberly at the silent white aristos. “Have you ever heard tell of the legend of—” he began, hesitated, then broke off, shaking his head as if deciding he had been about to say too much."), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“A sail!” The call winged down thinly from the crow’s nest. “A black sail to windward!”"), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“What manner of ship?” Slinoor shouted up."), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“I know not, master. I see only sail top.”"), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Keep her under view, boy,” Slinoor commanded."), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Under view it is, master.”"), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Slinoor paced to the starboard rail and back."), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Movarl’s sails are green,” Fafhrd said thoughtfully."), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Slinoor nodded. “Lankhmar’s are white. The pirates’ were red, mostly. Lankhmar’s sails once were black, but now that color’s only for funeral barges and they never venture out of sight of land. At least I’ve never known …”"), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The Mouser broke in with, “You spoke of dark antecedents of this voyaging. Why dark?”"), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Slinoor drew them back against the taffrail, away from the stocky helmsmen. Fafhrd ducked a little, passing under the arching tiller. They looked all three into the twisting wake, their heads bent together."), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Slinoor said, “You’ve been out of Lankhmar. Did you know this is not the first gift-fleet of grain to Movarl?”"), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The Mouser nodded. “We’d been told there was another. Somehow lost. In a storm, I think. Glipkerio glossed over it.”"), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“There were two,” Slinoor said tersely. “Both lost. Without a living trace. There was no storm.”"), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“What then?” Fafhrd asked, looking around as the rats chittered a little. “Pirates?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Movarl had already whipped the pirates east. Each of the two fleets was galley-guarded like ours. And each sailed off into fair weather with a good west wind.” Slinoor smiled thinly. “Doubtless Glipkerio did not tell you of these matters for fear you might beg off. We sailors and the Lankhmarines obey for duty and the honor of the City, but of late Glipkerio’s had trouble hiring the sort of special agents he likes to use for second bowstrings. He has brains of a sort, our overlord has, though he employs them mostly to dream of visiting other world bubbles in a great diving-bell or sealed metallic diving-ship, while he sits with trained girls watching trained rats and buys off Lankhmar’s enemies with gold and repays Lankhmar’s ever-more-greedy friends with grain, not soldiers.” Slinoor grunted. “Movarl grows most impatient, you know. He threatens, if the grain comes not, to recall his pirate-patrol, league with the land-Mingols and set them at Lankhmar.”"), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Northerners, even though not snow-dwelling, league with Mingols?” Fafhrd objected. “Impossible!”"), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Slinoor looked at him. “I’ll say just this, ice-eating Northerner. If I did not believe such a league both possible and likely—and Lankhmar thereby in dire danger—I would never have sailed with this fleet, honor and duty or no. Same’s true of Lukeen, who commands the galley. Nor do I think Glipkerio would otherwise be sending to Movarl at Kvarch Nar his noblest performing rats and dainty Hisvet.”"), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Fafhrd growled a little. “You say both fleets were lost without a trace?” he asked incredulously."), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Slinoor shook his head. “The first was. Of the second, some wreckage was sighted by an Ilthmar trader Lankhmar-bound. The deck of only one grain ship. It had been ripped off its hull, splinteringly—how or by what, the Ilthmart dared not guess. Tied to a fractured stretch of railing was the ship’s master, only hours dead. His face had been nibbled, his body gnawed.”"), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Fish?” the Mouser asked."), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Seabirds?” Fafhrd inquired."), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Dragons?” a third voice suggested, high, breathless, and as merry as a schoolgirl’s. The three men turned around, Slinoor with guilty swiftness."), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The Demoiselle Hisvet stood as tall as the Mouser, but judging by her face, wrists, and ankles was considerably slenderer. Her face was delicate and taper-chinned with small mouth and pouty upper lip that lifted just enough to show a double dash of pearly tooth. Her complexion was creamy pale except for two spots of color high on her cheeks. Her straight fine hair, which grew low on her forehead, was pure white touched with silver and all drawn back through a silver ring behind her neck, whence it hung unbraided like a unicorn’s tail. Her eyes had china whites but darkly pink irises around the large black pupils. Her body was enveloped and hidden by a loose robe of violet silk except when the wind briefly molded a flat curve of her girlish anatomy. There was a violet hood, half thrown back. The sleeves were puffed but snug at the wrists. She was bare-foot, her skin showing as creamy there as on her face, except for a tinge of pink about the toes."), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She looked them all three one after another quickly in the eye. “You were whispering of the fleets that failed,” she said accusingly. “Fie, Master Slinoor. We must all have courage.”"), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Aye,” Fafhrd agreed, finding that a cue to his liking. “Even dragons need not daunt a brave man. I’ve often watched the sea monsters, crested, horned, and some two-headed, playing in the waves of outer ocean as they broke around the rocks sailors call the Claws. They were not to be feared, if a man remembered always to fix them with a commanding eye. They sported lustily together, the man dragons pursuing the woman dragons and going—” Here Fafhrd took a tremendous breath and then roared out so loudly and wailingly that the two helmsmen jumped—“"), _c('i', [_vm._v("Hoongk! Hoongk!")]), _vm._v("”"), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Fie, Swordsman Fafhrd,” Hisvet said primly, a blush mantling her cheeks and forehead. “You are most indelicate. The sex of dragons—”"), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("But Slinoor had whirled on Fafhrd, gripping his wrist and now crying, “Quiet, you monster-fool! Know you not we sail tonight by moonlight past the Dragon Rocks? You’ll call them down on us!”"), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“There are no dragons in the Inner Sea,” Fafhrd laughingly assured him."), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“There’s something that tears ships,” Slinoor asserted stubbornly."), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The Mouser took advantage of this brief interchange to move in on Hisvet, rapidly bowing thrice as he approached."), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“We have missed the great pleasure of your company on deck, Demoiselle,” he said suavely."), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Alas, sir, the sun mislikes me,” she answered prettily. “Now his rays are mellowed as he prepared to submerge. Then too,” she added with an equally pretty shudder, “these rough sailors—” She broke off as she saw that Fafhrd and the master of "), _c('i', [_vm._v("Squid")]), _vm._v(" had stopped their argument and returned to her. “Oh, I meant not you, dear Master Slinoor,” she assured him, reaching out and almost touching his black robe."), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Would the Demoiselle fancy a sun-warmed, wind-cooled black plum of Sarheenmar?” the Mouser suggested, delicately sketching in the air with Cat’s Claw."), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“I know not,” Hisvet said, eyeing the dirk’s needle-like point. “I must be thinking of getting the White Shadows below before the evening’s chill is upon us.”"), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“True,” Fafhrd agreed with a flattering laugh, realizing she must mean the white rats. “But ’twas most wise of you, Little Mistress, to let them spend the day on deck, where they surely cannot hanker so much to sport with the Black Shadows—I mean, of course, their black free commoner brothers, and slim delightful sisters, to be sure, hiding here and there in the hold.”"), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“There are no rats on my ship, sportive or otherwise,” Slinoor asserted instantly, his voice loud and angry. “Think you I run a rat-brothel? Your pardon, Demoiselle,” he added quickly to Hisvet. “I mean, there are no common rats aboard "), _c('i', [_vm._v("Squid")]), _vm._v(".”"), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Then yours is surely the first grain ship so blessed,” Fafhrd told him with indulgent reasonableness."), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The sun’s vermilion disk touched the sea to the west and flattened like a tangerine. Hisvet leaned back against the taffrail under the arching tiller. Fafhrd was to her right, the Mouser to her left with the plums hanging just beyond him, near the silver cages. Slinoor had moved haughtily forward to speak to the helmsmen, or pretend to."), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“I’ll take that plum now, Dirksman Mouser,” Hisvet said softly."), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("As the Mouser turned away in happy obedience and with many a graceful gesture, delicately palpating the net bag to find the most tender fruit, Hisvet stretched her right arm out sideways and without looking once at Fafhrd slowly ran her spread-fingered hand through the hair on his chest, paused when she reached the other side to grasp a fistful and tweak it sharply, then trailed her fingers rightly back across the hair she had ruffled."), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Her hand came back to her just as the Mouser turned around. She kissed the palm lingeringly, then reached it across her body to take the black fruit from the point of the Mouser’s dirk. She sucked delicately at the prick Cat’s Claw had made and shivered."), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Fie, sir,” she pouted. “You told me ’twould be sun-warmed and ’tis not. Already all things grow chilly with evening.” She looked around her thoughtfully. “Why, Swordsman Fafhrd is all gooseflesh,” she announced, then blushed and tapped her lips reprovingly. “Close your jerkin, sir. ’Twill save you from catarrh and perchance from further embarrassment a girl who is unused to any sight of man-flesh save in slaves.”"), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Here is a tastier plum,” the Mouser called from beside the bag. Hisvet smiled at him and lightly tossed him back-handed the plum she’d sampled. He dropped that overboard and tossed her the second plum. She caught it deftly, lightly squeezed it, touched it to her lips, shook her head sadly though still smiling, and tossed back the plum. The Mouser, smiling gently too, caught it, dropped it overboard and tossed her a third. They played that way for some time. A shark following in the wake of the "), _c('i', [_vm._v("Squid")]), _vm._v(" got a stomachache."), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The black kitten came single-footing back along the starboard rail with a sharp eye to larboard. Fafhrd seized it instantly as any good general does opportunity in the heat of battle.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Have you seen the ship’s catling, Little Mistress?” he called, crossing to Hisvet, the kitten almost hidden in his big hands. “Or perhaps we should call the "), _c('i', [_vm._v("Squid")]), _vm._v(" the catling’s ship, for she adopted it, skipping by herself aboard just as we sailed. Here, Little Mistress. It feels sun-toasted now, warmer than any plum,” and he reached the kitten out sitting on the palm of his right hand."), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("But Fafhrd had been forgetting the kitten’s point of view. Its fur stood on end as it saw itself being carried toward the rats and now, as Hisvet stretched out her hand toward it, showing her upper teeth in a tiny smile and saying, “Poor little waif,” the kitten hissed fiercely and raked out stiff-armed with spread claws."), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Hisvet drew back her hand with a gasp. Before Fafhrd could drop the kitten or bat it aside, it sprang to the top of his head and from there onto the highest point of the tiller."), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The Mouser darted to Hisvet, crying meanwhile at Fafhrd, “Dolt! Lout! You knew the beast was half wild!” Then, to Hisvet, “Demoiselle! Are you hurt?”"), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Fafhrd struck angrily at the kitten and one of the helmsmen came back to bat at it too, perhaps because he thought it improper for kittens to walk on the tiller. The kitten made a long leap to the starboard rail, slipped over it, and dangled by two claws above the curving water."), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Hisvet was holding her hand away from the Mouser and he was saying, “Better let me examine it, Demoiselle. Even the slightest scratch from a filthy ship’s cat can be dangerous,” and she was saying, almost playfully, “No, Dirksman, I tell you it’s nothing.”"), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Fafhrd strode to the starboard rail, fully intending to flick the kitten overboard, but somehow when he came to do it he found he had instead cupped the kitten’s rear in his hand and lifted it back on the rail. The kitten instantly sank its teeth deeply in the root of his thumb and fled up the aftermast. Fafhrd with difficulty suppressed a great yowl. Slinoor laughed."), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Nevertheless, I will examine it,” the Mouser said masterfully and took Hisvet’s hand by force. She let him hold it for a moment, then snatched it back and drawing herself up said frostily, “Dirksman, you forget yourself. Not even her own physician touches a Demoiselle of Lankhmar, he touches only the body of her maid, on which the Demoiselle points out her pains and symptoms. Leave me, Dirksman.”"), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The Mouser stood huffily back against the taffrail. Fafhrd sucked the root of his thumb. Hisvet went and stood beside the Mouser. Without looking at him, she said softly, “You should have asked me to call my maid. She’s quite pretty.”"), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Only a fingernail clipping of red sun was left on the horizon. Slinoor addressed the crow’s nest: “What of the black sail, boy?”"), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“She holds her distance, master,” the cry came back. “She courses on abreast of us.”"), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The sun went under with a faint green flash. Hisvet bent her head sideways and kissed the Mouser on the neck, just under the ear. Her tongue tickled."), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Now I lose her, master,” the crow’s nest called. “There’s mist to the northwest. And to the northeast … a small black cloud … like a black ship specked with light … that moves through the air. And now that fades too. All gone, master.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Hisvet straightened her head. Slinoor came toward them muttering, “The crow’s nest sees too much.” Hisvet shivered and said, “The White Shadows will take a chill. They’re delicate, Dirksman.” The Mouser breathed, “You are Ecstasy’s White Shadow, Demoiselle,” then strolled toward the silver cages, saying loudly for Slinoor’s benefit, “Might we not be privileged to have a show of them, Demoiselle, tomorrow here on the afterdeck? ’Twould be wondrous instructive to watch you control them.” He caressed the air over the cages and said, lying mightily, “My, they’re fine handsome fellows.” Actually he was peering apprehensively for any of the little spears and swords Slinoor had mentioned. The twelve rats looked up at him incuriously. One even seemed to yawn.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Slinoor said curtly, “I would advise against it, Demoiselle. The sailors have a mad fear and hatred of all rats. ’Twere best not to arouse it.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“But these are aristos,” the Mouser objected, while Hisvet only repeated, “They’ll take a chill.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Fafhrd, hearing this, took his hand out of his mouth and came hurrying to Hisvet, saying, “Little Mistress, may I carry them below? I’ll be gentle as a Kleshite nurse.” He lifted between thumb and third finger a cage with two rats in it. Hisvet rewarded him with a smile, saying, “I wish you would, gallant Swordsman. The common sailors handle them too roughly. But two cages are all you may safely carry. You’ll need proper help.” She gazed at the Mouser and Slinoor.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("So Slinoor and the Mouser, the latter much to his distaste and apprehension, must each gingerly take up a silver cage, and Fafhrd two, and follow Hisvet to her cabin below the afterdeck. The Mouser could not forbear whispering privily to Fafhrd, “Oaf! To make rat-grooms of us! May you get rat-bites to match your cat-bite!” At the cabin door Hisvet’s dark maid Frix received the cages, Hisvet thanked her three gallants most briefly and distantly and Frix closed the door against them. There was the muffled thud of a bar dropping across it and the jangle of a chain locking down the bar."), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  })]), _vm._v(" "), _c('p', {
    staticClass: "tcd"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Darkness grew on the waters. A yellow lantern was lit and hoisted to the crow’s nest. The black war galley "), _c('i', [_vm._v("Shark")]), _vm._v(", its brown sail temporarily furled, came rowing back to fuss at "), _c('i', [_vm._v("Clam")]), _vm._v(", next ahead of "), _c('i', [_vm._v("Squid")]), _vm._v(" in line, for being slow in getting up its masthead light, then dropped back by "), _c('i', [_vm._v("Squid")]), _vm._v(" while Lukeen and Slinoor exchanged shouts about a black sail and mist and ship-shaped small black clouds and the Dragon Rocks. Finally the galley went bustling ahead again with its Lankhmarines in browned-iron chain mail to take up its sailing station at the head of the column. The first stars twinkled, proof that the sun had not deserted through the waters of eternity to some other world bubble, but was swimming as he should back to the east under the ocean of the sky, errant rays from him lighting the floating star-jewels in his passage."), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("After moonrise that night Fafhrd and the Mouser each found private occasion to go rapping at Hisvet’s door, but neither profited greatly thereby. At Fafhrd’s knock Hisvet herself opened the small grille set in the larger door, said swiftly, “Fie, for shame, Swordsman! Can’t you see I’m undressing?” and closed it instantly. While when the Mouser asked softly for a moment with “Ecstasy’s White Shadow,” the merry face of the dark maid Frix appeared at the grille, saying, “My mistress bid me kiss my hand good night to you.” Which she did and closed the grille."), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Fafhrd, who had been spying, greeted the crestfallen Mouser with a sardonic, “Ecstasy’s White Shadow!”"), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Little Mistress!” the Mouser retorted scathingly."), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Black Plum of Sarheenmar!”"), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Kleshite Nurse!”"), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Neither hero slept restfully that night and two-thirds through it the "), _c('i', [_vm._v("Squid")]), _vm._v("’s gong began to sound at intervals, with the other ships’ gongs replying or calling faintly. When at dawn’s first blink the two came on deck, "), _c('i', [_vm._v("Squid")]), _vm._v(" was creeping through fog that hid the sail top. The two helmsmen were peering about jumpily, as if they expected to see ghosts. The sails were barely filled. Slinoor, his eyes dark-circled by fatigue and big with anxiety, explained tersely that the fog had not only slowed but disordered the grain fleet."), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“That’s "), _c('i', [_vm._v("Tunny")]), _vm._v(" next ahead of us. I can tell by her gong note. And beyond "), _c('i', [_vm._v("Tunny")]), _vm._v(", "), _c('i', [_vm._v("Carp")]), _vm._v(". Where’s "), _c('i', [_vm._v("Clam")]), _vm._v("? What’s "), _c('i', [_vm._v("Shark")]), _vm._v(" about? And still not certainly past the Dragon Rocks! Not that I want to see ’em!”"), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Do not some captains call them the Rat Rocks?” Fafhrd interposed. “From a rat-colony started there from a wreck?”"), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Aye,” Slinoor allowed and then grinning sourly at the Mouser, observed, “Not the best day for a rat-show on the afterdeck, is it? Which is some good from this fog. I can’t abide the lolling white brutes. Though but a dozen in number they remind me too much of the Thirteen. Have you ever heard tell of the legend of the Thirteen?”"), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“I have,” Fafhrd said somberly. “A wise woman of the Cold Waste once told me that for each animal kind—wolves, bats, whales, it holds for all and each—there are always thirteen individuals having almost manlike (or demonlike!) wisdom and skill. Can you but find and master this inner circle, the Wise Woman said, then through them you can control all animals of that kind.”"), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Slinoor looked narrowly at Fafhrd and said, “She was not an altogether stupid woman.”"), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The Mouser wondered if for men also there was an inner circle of Thirteen."), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The black kitten came ghosting along the deck out of the fog forward. It made toward Fafhrd with an eager mew, then hesitated, studying him dubiously."), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Take for example, cats,” Fafhrd said with a grin. “Somewhere in Nehwon today, mayhap scattered but more likely banded together, are thirteen cats of superfeline sagacity, somehow sensing and controlling the destiny of all catkind.”"), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“What’s this one sensing now?” Slinoor demanded softly."), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The black kitten was staring to larboard, sniffing. Suddenly its scrawny body stiffened, the hair rising along its back and its skimpy tail a-bush."), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“"), _c('i', [_vm._v("Hoongk!")]), _vm._v("”"), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Slinoor turned to Fafhrd with a curse, only to see the Northerner staring about shut-mouthed and startled. Clearly "), _c('i', [_vm._v("he")]), _vm._v(" had not bellowed."), _c('span', {
    staticClass: "Apple-converted-space"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b')])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-239d4be0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section3.vue
// module id = 72
// module chunks = 0